<template>
  <div class="article-header">
    <div class="article-header-cover" :style="coverStyle" />
    <div class="article-header-body">
      <h1 class="article-header-title">
        {{ title }}
      </h1>
      <div class="article-header-info">
        <span v-if="volume">
          {{ volume.periodical && volume.periodical.title }}&nbsp;
          {{ volume.publication_date.slice(0,7) }}&nbsp;
          Vol. {{ volume.volume }} /
        </span>
        <span v-for="author in authors" :key="author.id" class="byline">
          <RouterLink
            :to="{ name:'authorById', params: { locale: $i18n.localePath(), id: author.id } }"
            :title="author.name"
            class="author"
          >
            {{ author.name }}
          </RouterLink>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ArticleHeader',
  props: {
    coverSrc: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    volume: {
      type: Object,
      default: () => {}
    },
    authors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      coverStyle: {
        backgroundImage: this.coverSrc ? `url(${this.coverSrc})` : `url('/img/read/cover-default.svg')`,
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.article-header {
  display: flex;
  margin-bottom: 47px;
  .article-header-cover {
    width: 195px;
    height: 259px;
    // not allowed to grow and shrink
    flex: 0 0 auto;
  }
  .article-header-body {
    margin-left: 18px;
    overflow: hidden;
    .article-header-title {
      color: #525252;
      font-size: 36px;
      font-weight: bold;
      margin: 0 0 16px 0;
    }
    .article-header-info {
      font-size: 16px;
      font-weight: 700;
      line-height: 26px;
      color: $grey-9b;
      .author {
        @include default-link-hover();
      }
    }
  }

}
@media only screen and (max-width: 767.98px) {
  .article-header {
    flex-direction: column;
    margin-bottom: 24px;
    .article-header-cover {
      margin-bottom: 24px;
      width: 100px;
      height: 133px;
    }
    .article-header-body {
      margin-left: 0;
      .article-header-title {
        font-size: 24px;
        font-weight: 500;
        margin: 0 0 4px 0;
      }
    }
  }
}
</style>
